<div fxLayout="row" fxLayoutAlign="space-between center">
  <div fxLayout="row" fxLayoutAlign="start center">
    <mat-icon class="mr-4">error_outline</mat-icon>
    <div [innerHTML]="data?.msg"></div>
  </div>
  <div fxLayout="row">
    <!-- <button mat-flat-button color="green"></button> -->
    @if (data.withCancel) {
    <button mat-flat-button color="white" (click)="dismiss(true)" class="ml-4">cancel</button>
    }
    <button mat-flat-button color="white" (click)="dismiss()" class="ml-2">
      {{ data.action }}
    </button>
  </div>
</div>
